import { capitalCase } from 'change-case';
import { isObject } from 'lodash';
import sha256 from 'crypto-js/sha256';
import Hex from 'crypto-js/enc-hex';

export const trimMultipleWhiteSpaces = (str: string): string => str.replace(/\s+/g, ' ');
export const capitalize = (str: string): string =>
  cleanSearchInput(str)
    .split(' ')
    .map((word) => {
      if (!word) return word;
      return word[0].toUpperCase() + word.substring(1).toLowerCase();
    })
    .join(' ');

export const transformScope = (str: string): string => {
  str = str.replace(/[._]/g, ' ');
  str = capitalCase(str);
  return str;
};

export const convertToQueryParams = (filters: any): string =>
  Object.entries(filters).reduce<string>((filterString, [filterKey, filterValue]) => {
    if ((Array.isArray(filterValue) && !filterValue.length) || !filterValue) {
      return filterString;
    }
    return (filterString += `&${filterKey}=${filterValue}`);
  }, '');

export const cleanSearchInput = (search: string): string => trimMultipleWhiteSpaces(search).trim();

export const containsSpecialCharacters = (str: string, regex?: any): boolean => {
  const specialCharactersPattern: RegExp = regex instanceof RegExp ? regex : /[^a-zA-Z0-9. ]/;

  return specialCharactersPattern.test(str);
};

export const isValidEmail = (email: string): boolean => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailPattern.test(email);
};

export const isValidJsonString = (str: string): boolean => {
  try {
    const parsed = JSON.parse(str);
    return isObject(parsed);
  } catch (e) {
    return false;
  }
}

const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .trim();

const toSlug = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

export const toPascalCase = (value: string) =>
  normalize(value)
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');

const shortHash = (value: string, length = 9) =>
  sha256(value).toString(Hex).slice(0, length);

export const generateId = (title: string) => {
  const slug = toSlug(title);
  const hash = shortHash(title);
  return `${slug}-${hash}`;
};
